import React from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../components/common/layout';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { colors } from '../styles/theme';

// icons
import { HiOutlineChevronRight } from '@react-icons/all-files/hi/HiOutlineChevronRight';
import { MdCreditCard } from '@react-icons/all-files/md/MdCreditCard';
import { MdBusiness } from '@react-icons/all-files/md/MdBusiness';
import { MdAddShoppingCart } from '@react-icons/all-files/md/MdAddShoppingCart';
import { MdPersonOutline } from '@react-icons/all-files/md/MdPersonOutline';
import { GoCheck } from '@react-icons/all-files/go/GoCheck';
import { FiShare } from '@react-icons/all-files/fi/FiShare';
import { IoIosSquare } from '@react-icons/all-files/io/IoIosSquare';
import { GiCheckMark } from '@react-icons/all-files/gi/GiCheckMark';

// components
import Rating from '@material-ui/lab/Rating';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Avatar from '@material-ui/core/Avatar';
import { deepOrange, deepPurple } from '@material-ui/core/colors';

// custom components
import Media from '../components/styledCompoBreakpoint';
import FluidImgs from '../components/fluidImgs';
import CommnetSystem from '../components/commentSystem';
import Badge from '../components/badge';

// material ui
const BorderLinearProgress = withStyles(theme => ({
  root: {
    height: 10,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}))(LinearProgress);

const useStylesProgressBar = makeStyles({
  root: {
    flexGrow: 1,
  },
});

const useStylesAvatar = makeStyles(theme => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
}));

// custom
const Emoji = props => (
  <span
    className="emoji"
    role="img"
    aria-label={props.label ? props.label : ''}
    aria-hidden={props.label ? 'false' : 'true'}
    style={{ fontFamily: 'Segoe UI Emoji' }}
  >
    {props.symbol}
  </span>
);

const CourseMainSection = styled.section`
  background-color: ${colors.mainDark};
  color: #fff;
  .breadcrumb {
    align-items: center;
    font-size: 0.813rem;
    color: ${colors.mainLightText};
    a {
      font-size: 0.813rem;
      color: ${colors.mainLightText};
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  h2 {
    font-size: 1.625rem;
    line-height: 1.5;
  }
  .review {
    font-size: 0.875rem;
    .MuiRating-iconEmpty {
      color: rgb(255 255 255 / 26%);
    }
  }
  .ncs-num {
    font-size: 0.875rem;
    color: #9eadb7;
  }
  .instructors {
    font-size: 0.875rem;
  }
  .production_date {
    font-size: 0.813rem;
    color: #9eadb7;
  }

  ${Media.md`
  h2 {
    font-size: 1.325rem;
  }
  `}
`;

const PriceUnderTablet = styled.div`
  border-top: 1px solid #ffffff12;
  border-bottom: 1px solid #ffffff12;
  background-color: #0d2538;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 1rem;

  .normal-class-price {
    p:first-child {
      color: #3ad88f;
    }
    p:not(:first-child) svg {
      color: #3ad88f;
    }
  }

  .businesss-grants {
    p:first-child {
      color: #e87b7b;
    }
    p:not(:first-child) svg {
      color: #e87b7b;
    }
  }

  .neabaca_grants {
    p:first-child {
      color: #9494ff;
    }
    p:not(:first-child) svg {
      color: #9494ff;
    }
  }

  .normal-class-price,
  .businesss-grants,
  .neabaca_grants {
    p:not(:first-child) {
      font-size: 0.875rem;
      color: #fff;
      svg {
        width: 0.5rem;
        margin-right: 5px;
      }
    }
  }
`;

const StickBottomBar = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 1px 10px rgb(0 0 0 / 15%);
  z-index: 9999;

  button:nth-of-type(1) {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      display: block;
      width: 1px;
      height: 50%;
      top: 28%;
      right: -2px;
      background-color: #c7c7c7;
    }
  }
  .apply-btn {
    background-color: #ff7e33;
    color: #fff;
  }
`;

const FixedBox = styled.div`
  position: sticky;
  min-width: 335px;
  width: 17%;
  top: 110px;
  background: #fff;
  color: #000;
  border: 1px solid #efefef;
  z-index: 9;

  .apply-btn {
    display: block;
    width: 100%;
    background-color: #ff7e33;
    color: #fff;
    transition: 0.5s;

    &:hover {
      background-color: #eb5e00;
    }
  }

  .price-info {
    .price-info {
      border-top: 1px solid #dee2e6;
    }
  }
  .sub-btns {
    position: relative;
    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 1px;
      height: 50%;
      top: 25%;
      left: 50%;
      background-color: #ddd;
    }

    .sub-btn {
      font-size: 0.938rem;
      color: #444;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .normal-class-price {
    p:first-child {
      color: #198754;
    }
    p:not(:first-child) svg {
      color: #198754;
    }
  }

  .businesss-grants {
    p:first-child {
      color: #e45454;
    }
    p:not(:first-child) svg {
      color: #e45454;
    }
  }

  .neabaca_grants {
    p:first-child {
      color: #3232ce;
    }
    p:not(:first-child) svg {
      color: #3232ce;
    }
  }

  .normal-class-price,
  .businesss-grants,
  .neabaca_grants {
    p:not(:first-child) {
      font-size: 0.938rem;
      color: #222;
      svg {
        width: 0.5rem;
        margin-right: 5px;
      }
    }
  }

  .extra-info {
    background-color: #f7f7f7;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    color: #505050;
  }
`;

const CourseContentSection = styled.section`
  h3 {
    position: relative;
    margin-bottom: 1.188rem;
    padding-left: 0.75rem;
    font-size: 1.375rem;
    font-weight: 700;
    .small {
      font-size: 1rem;
      letter-spacing: -1px;
    }
  }
  h3.pre-vertical-bar::after {
    content: '';
    position: absolute;
    display: block;
    width: 3px;
    height: 90%;
    left: 0;
    top: 10%;
    background-color: #ff7e33;
  }

  ul {
    margin-left: 1rem;
    padding-left: 1.5rem;
  }

  .pre-intro {
    font-size: 1.188rem;
  }
  .summaries {
    p {
      margin-left: 1rem;
      line-height: 1.6;
    }
  }

  .objectives {
    ul {
      padding: 0;
      list-style: none;
      li {
        list-style: none;
        svg {
          color: ${colors.mainLight};
        }
      }
    }
  }

  .instructors {
    h4 {
      font-size: 1rem;
    }
    p {
      font-size: 0.938rem;
      color: #585858;
    }
  }

  .contents {
    ul li {
      list-style: none;
    }
  }
`;

const ReviewWrapper = styled.div`
  .MuiRating-decimal {
    margin-right: -3px;
  }
  .review-head {
    > div:first-child {
      span {
        color: #444;
      }
    }
    > p {
      color: #777;
    }
    .star-avg-wrapper {
      strong {
        font-size: 3rem;
        line-height: 1;
      }
      .text {
        font-size: 0.938rem;
        font-weight: 500;
      }
    }
  }
  .review-progressbar-wrapper {
    span {
      width: 100px;
      font-size: 0.875rem;
    }
  }
  .review-list {
    .review-ctt {
      background-color: #f8f8f8;
      p {
        font-size: 0.925rem;
      }
      .review-date {
        font-size: 0.925rem;
        color: #777;
      }
    }
    .star-rate-count {
      font-size: 0.9rem;
      color: #777;
    }
  }
`;

const minusCalc = (num1, num2) => {
  const first = parseFloat(num1.replace(',', ''));
  const second = parseFloat(num2.replace(',', ''));
  const calced = first - second;
  return calced.toLocaleString();
};

export default function Template({ pageContext: { courseData, reviewData } }) {
  const targets = courseData.learning_targets.split('\r\n');
  const objectives = courseData.objectives.split('\r\n');
  const efforts = courseData.efforts.split('\r\n');
  const instructorInfo =
    courseData.instructors_info && courseData.instructors_info.split('\r\n');
  const instructorEdu =
    courseData.instructors_education &&
    courseData.instructors_education.split('\r\n');
  const instructorCareer =
    courseData.instructors_career &&
    courseData.instructors_career.split('\r\n');

  const avg =
    reviewData.reduce((accReview, currReview) => {
      return parseFloat(accReview) + parseFloat(currReview.node.star_rate);
    }, 0) / reviewData.length;
  const starRateAvg = Math.ceil(avg * 2) / 2 || 0;

  const year = courseData.production_date.slice(0, 4);
  const month = courseData.production_date.slice(4, 6);

  const classesProgressBar = useStylesProgressBar();
  const classesAvatar = useStylesAvatar();

  let countReivewPerRate = [
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
    [0, 0],
  ];
  (function() {
    reviewData.map(review => {
      let rate = parseFloat(review.node.star_rate);
      if (rate > 4) {
        countReivewPerRate[0][0] += 1;
        countReivewPerRate[0][1] =
          (countReivewPerRate[0][0] / reviewData.length) * 100;
      } else if (rate > 3) {
        countReivewPerRate[1][0] += 1;
        countReivewPerRate[1][1] =
          (countReivewPerRate[1][0] / reviewData.length) * 100;
      } else if (rate > 2) {
        countReivewPerRate[2][0] += 1;
        countReivewPerRate[2][1] =
          (countReivewPerRate[2][0] / reviewData.length) * 100;
      } else if (rate > 1) {
        countReivewPerRate[3][0] += 1;
        countReivewPerRate[3][1] =
          (countReivewPerRate[3][0] / reviewData.length) * 100;
      } else if (rate <= 1) {
        countReivewPerRate[4][0] += 1;
        countReivewPerRate[4][1] =
          (countReivewPerRate[4][0] / reviewData.length) * 100;
      }
      return countReivewPerRate;
    });
  })();

  return (
    <Layout>
      <Helmet htmlAttributes={{ lang: 'ko' }}>
        <title>{courseData.class_title}</title>
      </Helmet>
      <CourseMainSection className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-5 col-xl-4">
              <a href={courseData.preview_url} target="_blank" rel="noreferrer">
                {courseData.thumnail ? (
                  // 강의 썸네일 있을 경우
                  <FluidImgs
                    filename={courseData.thumnail}
                    objectFit="cover"
                    alt={courseData.class_title + '- Featured Shot'}
                    type="mobileFullWidth"
                    className="rounded"
                  />
                ) : (
                  // 썸네일 없을 경우
                  <FluidImgs
                    filename="default-thumnail16x9.jpg"
                    objectFit="cover"
                    alt="썸네일 준비중"
                    type="mobileFullWidth"
                    className="rounded"
                  />
                )}
              </a>
            </div>
            <div className="col-12 mt-3 col-lg-7 col-xl-7">
              <p className="breadcrumb mb-1">
                <Link to={`/${courseData.large_categories}`}>
                  {courseData.large_categories}
                </Link>
                <HiOutlineChevronRight className="mx-1" />
                <Link
                  to={`/${courseData.large_categories}/${courseData.medium_categories}`}
                >
                  {courseData.medium_categories}
                </Link>
                <HiOutlineChevronRight className="mx-1" />
                {courseData.small_categories}
              </p>

              <h2 className="mb-1">{courseData.class_title}</h2>

              <div className="mb-1">
                {courseData._small_businesses_grants_.trim() !== '-' && (
                  <Badge classKind="businesses_grants">사업주훈련</Badge>
                )}
                {courseData.neabaca_grants.trim() !== '-' && (
                  <Badge classKind="neabaca_grants">내일배움카드</Badge>
                )}
                {courseData._small_businesses_grants_.trim() === '-' &&
                  courseData.neabaca_grants.trim() === '-' && (
                    <Badge classKind="normalClass">일반과정</Badge>
                  )}
              </div>
              <PriceUnderTablet className="d-block d-lg-none">
                {/* 고용여부가 N일 경우 총수강료 표시 (일반수강) */}
                {courseData.refund.toUpperCase() === 'N' && (
                  <div className="p-2 mb-0 normal-class-price price-info">
                    <p className="mb-2">
                      <MdPersonOutline /> <strong>일반수강</strong>
                    </p>
                    <p className="mb-1">
                      <IoIosSquare />
                      수강료:{' '}
                      <strong>{courseData._total_price_.trim()}원</strong>
                    </p>
                  </div>
                )}
                {/* 고용여부가 Y이고 우선기업 지원금이 있을 경우
                  기업 지원금 표시 */}
                {courseData.refund.toUpperCase() === 'Y' &&
                  courseData._small_businesses_grants_.trim() !==
                    ('-' || '') && (
                    <div className="p-2 mb-0 businesss-grants price-info">
                      <p className="mb-2">
                        <MdBusiness /> <strong>사업주훈련</strong>
                      </p>
                      <p className="mb-1">
                        <IoIosSquare />
                        우선기업 지원금:{' '}
                        <strong>
                          {courseData._small_businesses_grants_.trim()}원
                        </strong>
                      </p>
                      <p className="mb-1">
                        <IoIosSquare />
                        중견기업 지원금:{' '}
                        <strong>
                          {courseData._medium_businesses_grants_.trim()}원
                        </strong>
                      </p>
                      <p className="mb-1">
                        <IoIosSquare />
                        대기업 지원금:{' '}
                        <strong>
                          {courseData.large_businesses_grants.trim()}원
                        </strong>
                      </p>
                    </div>
                  )}

                {/* 고용여부가 Y이고 내배카 금액이 있을 경우
              내배카 지원금 표시 */}
                {courseData.refund.toUpperCase().trim() === 'Y' &&
                  courseData.neabaca_grants.trim() !== ('-' || '') && (
                    <div className="p-2 mb-0 neabaca_grants price-info">
                      <p className="mb-2">
                        <MdCreditCard /> <strong>내일배움카드</strong>
                      </p>
                      <p className="mb-1">
                        <IoIosSquare />
                        교육비: {courseData._total_price_.trim()}원
                      </p>
                      <p className="mb-1">
                        <IoIosSquare />
                        내배카 지원금: {courseData.neabaca_grants.trim()}원
                      </p>
                      <p className="mb-1">
                        <IoIosSquare />
                        자부담금:{' '}
                        <strong>
                          {minusCalc(
                            courseData._total_price_,
                            courseData.neabaca_grants,
                          )}
                          원
                        </strong>
                      </p>
                    </div>
                  )}
              </PriceUnderTablet>
              {// ncs 코드가 없는 경우 제외하고 표시
              courseData.ncs_code !== ('' || '-') && (
                <p className="ncs-num mb-2">NCS: {courseData.ncs_code}</p>
              )}
              <p className="review d-flex mb-2 align-items-center">
                <Rating
                  name="half-rating-read"
                  // 리뷰 별점 || 리뷰 별점 없을 경우
                  defaultValue={starRateAvg}
                  precision={0.5}
                  size="small"
                  readOnly
                />
                <span className="me-2">({starRateAvg})</span>
                <span>{reviewData.length}개의 수강평</span>
              </p>
              <p className="instructors mb-2">
                {courseData.instructors_and_affiliation || ''}
              </p>
              <p className="mb-2 production_date">
                제작 <span>{year}.</span>
                <span>{month}.</span>
              </p>
            </div>
          </div>
        </div>
      </CourseMainSection>
      <CourseContentSection className="container py-4">
        <div className="row">
          <div className="col-lg-7 col-xl-8 col-xxl-9">
            <div className="pre-intro mb-3 p-3">
              {' '}
              <p>
                <Emoji symbol="✨" label="Sparkles" />
                <strong>{courseData.level}자</strong>분들을 위한{' '}
                <strong>
                  {courseData.classification.trim() === '기타' ||
                  courseData.classification.trim() === ' ' ||
                  courseData.classification.trim() === '-'
                    ? courseData.small_categories
                    : courseData.classification}
                </strong>{' '}
                강의입니다
                <Emoji symbol="✨" label="Sparkles" />
              </p>
            </div>
            <div className="mb-3 p-3 summaries">
              <h3 className="pre-vertical-bar">강의소개</h3>
              <p>{courseData.summaries}</p>
            </div>
            <div className="mb-3 p-3">
              <h3 className="pre-vertical-bar">강의대상</h3>
              <ul>
                {targets.map(
                  (target, i) =>
                    // 강의 소개 빈 값 있을 경우 제외하고 표시
                    target !== '' && <li key={i}>{target}</li>,
                )}
              </ul>
            </div>
            <div className="objectives mb-3 p-3">
              <h3 className="pre-vertical-bar">강의목표</h3>
              <ul>
                {objectives.map(
                  (objective, i) =>
                    // 학습 목표 빈 값 있을 경우 제외하고 표시
                    objective !== '' && (
                      <li key={i} className="d-flex">
                        <span>
                          <GiCheckMark />
                        </span>
                        <p className="ms-2">{objective}</p>
                      </li>
                    ),
                )}
              </ul>
            </div>
            {courseData.instructors_and_affiliation && (
              <div className="instructors mb-3 p-3">
                <h3 className="pre-vertical-bar">강사 소개</h3>
                <div className="ps-3">
                  <div className="instructors-basic-info">
                    <h4 className="mb-2">
                      {courseData.instructors_and_affiliation} 강사
                    </h4>
                    {courseData.instructors_info &&
                      instructorInfo.map((info, i) => (
                        <p className="mb-1 ps-2" key={i}>
                          {info}
                        </p>
                      ))}
                  </div>

                  {courseData.instructors_education && (
                    <div className="instructors-edu-info">
                      <h4 className="mt-3 mb-2">학력사항</h4>
                      {instructorEdu.map((edu, i) => (
                        <p className="mb-1 ps-2" key={i}>
                          {edu}
                        </p>
                      ))}
                    </div>
                  )}

                  {courseData.instructors_career && (
                    <div className="instructors-career-info">
                      <h4 className="mt-3 mb-2">경력사항</h4>

                      {instructorCareer.map((career, i) => (
                        <p className="mb-1 ps-2" key={i}>
                          {career}
                        </p>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className="contents mb-3 p-3">
              <h3 className="pre-vertical-bar">
                강의목차{' '}
                <span className="samll">
                  총 {courseData._number_of_contents_}차시
                </span>
              </h3>
              <ul className="ps-1">
                {efforts.map(
                  (effort, i) =>
                    // 강의 목차 빈 값 있을 경우 제외하고 표시
                    effort !== '' && <li key={i}>{effort}</li>,
                )}
              </ul>
            </div>
            {!(courseData.textbook_title === '-' || courseData.textbook_title === ' ' || courseData.textbook_title === null) && (
              <div className="mb-3 p-3">
                <h3 className="pre-vertical-bar">교재정보(교육비포함)</h3>
                <div className="ps-4">
                  <p>교재명: {courseData.textbook_title}</p>
                  <p>가격: {courseData.textbook_price}</p>
                  <p>저자: {courseData.textbook_authors}</p>
                  <p>ISBN: {courseData.isbn}</p>
                </div>
              </div>
            )}
            {courseData.textbook.toUpperCase() === '개인도서구매' && (
              <div className="border rounded mb-3">
                <h3 className="pre-vertical-bar">교재정보(개인도서구매)</h3>
                <p>교재명: {courseData.textbook_title}</p>
                <p>저자: {courseData.textbook_authors}</p>
                <p>ISBN: {courseData.isbn}</p>
              </div>
            )}
            <ReviewWrapper className="mb-3 p-3">
              <div className="review-head">
                <div className="d-flex align-items-end mb-2">
                  <h3 className="mb-0 me-2 ps-0">수강후기</h3>
                  <span>
                    총 <strong>{reviewData.length}</strong>개의 리뷰
                  </span>
                </div>
                <p>수강생들이 직접 작성한 리뷰를 확인해보세요.</p>
                <div className="star-avg-wrapper d-flex flex-column flex-md-row align-items-center pb-3 pb-md-0 mb-0 border-top border-bottom">
                  <div className="d-flex flex-column justify-content-center text-center py-4 py-md-5 px-5">
                    <strong className="mb-1">{starRateAvg}</strong>
                    <Rating
                      name="half-rating-read"
                      // 리뷰 별점 || 리뷰 별점 없을 경우
                      defaultValue={starRateAvg}
                      precision={0.5}
                      size="small"
                      readOnly
                    />
                    <span className="text mt-2">수강 평점</span>
                  </div>
                  <div
                    className={`${classesProgressBar.root} w-100 ps-2 pe-xl-5 review-progressbar-wrapper`}
                  >
                    <div className="d-flex align-items-baseline justify-content-between">
                      <BorderLinearProgress
                        variant="determinate"
                        value={countReivewPerRate[0][1]}
                        className="mb-2 w-100"
                      />
                      <span className="px-2 text-center">
                        5점 ({countReivewPerRate[0][0]})
                      </span>
                    </div>
                    <div className="d-flex align-items-baseline justify-content-between">
                      <BorderLinearProgress
                        variant="determinate"
                        value={countReivewPerRate[1][1]}
                        className="mb-2 w-100"
                      />
                      <span className="px-2 text-center">
                        4점 ({countReivewPerRate[1][0]})
                      </span>
                    </div>
                    <div className="d-flex align-items-baseline justify-content-between">
                      <BorderLinearProgress
                        variant="determinate"
                        value={countReivewPerRate[2][1]}
                        className="mb-2 w-100"
                      />
                      <span className="px-2 text-center">
                        3점 ({countReivewPerRate[2][0]})
                      </span>
                    </div>
                    <div className="d-flex align-items-baseline justify-content-between">
                      <BorderLinearProgress
                        variant="determinate"
                        value={countReivewPerRate[3][1]}
                        className="mb-2 w-100"
                      />
                      <span className="px-2 text-center">
                        2점 ({countReivewPerRate[3][0]})
                      </span>
                    </div>
                    <div className="d-flex align-items-baseline justify-content-between">
                      <BorderLinearProgress
                        variant="determinate"
                        value={countReivewPerRate[4][1]}
                        className="w-100"
                      />
                      <span className="px-2 text-center">
                        1점 ({countReivewPerRate[4][0]})
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="review-body">
                {reviewData.map((review, i) => (
                  <div key={i} className="review-list py-3">
                    <div className="reviewr-summary d-flex align-items-center mb-3">
                      <div className={classesAvatar.root}>
                        <Avatar className={`${classesAvatar.large} me-3`}>
                          {review.node.reviewer.substr(0, 1)}
                        </Avatar>
                      </div>
                      <div>
                        <p className="reviewr mb-1">{review.node.reviewer}</p>
                        <p className="star-rating-wrapper d-flex align-items-center mb-0">
                          <Rating
                            name="half-rating-read"
                            // 리뷰 별점 || 리뷰 별점 없을 경우
                            defaultValue={parseFloat(review.node.star_rate)}
                            precision={0.5}
                            size="small"
                            readOnly
                          />
                          <span className="star-rate-count ms-1">
                            ({review.node.star_rate})
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="review-ctt pt-4 pb-3 px-4">
                      <p className="mb-0">{review.node.review}</p>
                      <p className="review-date mt-3 mb-0">
                        {new Date(review.node.date).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </ReviewWrapper>

            <CommnetSystem />
          </div>
          <div className="d-none d-lg-block col-lg-5 col-xl-4 col-xxl-3">
            <FixedBox className="p-3 rounded shadow-sm">
              <button type="button" className="btn btn-block mb-3 apply-btn">
                수강신청
              </button>
              <div className="d-flex justify-content-around align-content-center mb-3 sub-btns">
                <button type="button" className="btn btn-block w-50 sub-btn">
                  <MdAddShoppingCart /> 장바구니
                </button>
                <button type="button" className="btn btn-block w-50 sub-btn">
                  <FiShare /> 공유
                </button>
              </div>
              {/* 고용여부가 N일 경우 총수강료 표시 (일반수강) */}
              {courseData.refund.toUpperCase() === 'N' && (
                <div className="p-2 mb-2 normal-class-price price-info">
                  <p className="mb-2">
                    <MdPersonOutline /> <strong>일반수강</strong>
                  </p>
                  <p className="mb-1">
                    <IoIosSquare />
                    수강료: <strong>{courseData._total_price_.trim()}원</strong>
                  </p>
                </div>
              )}
              {/* 고용여부가 Y이고 우선기업 지원금이 있을 경우
                  기업 지원금 표시 */}
              {courseData.refund.toUpperCase() === 'Y' &&
                courseData._small_businesses_grants_.trim() !== ('-' || '') && (
                  <div className="p-2 mb-2 businesss-grants price-info">
                    <p className="mb-2">
                      <MdBusiness /> <strong>사업주훈련</strong>
                    </p>
                    <p className="mb-1">
                      <IoIosSquare />
                      우선기업 지원금:{' '}
                      <strong>
                        {courseData._small_businesses_grants_.trim()}원
                      </strong>
                    </p>
                    <p className="mb-1">
                      <IoIosSquare />
                      중견기업 지원금:{' '}
                      <strong>
                        {courseData._medium_businesses_grants_.trim()}원
                      </strong>
                    </p>
                    <p className="mb-1">
                      <IoIosSquare />
                      대기업 지원금:{' '}
                      <strong>
                        {courseData.large_businesses_grants.trim()}원
                      </strong>
                    </p>
                  </div>
                )}

              {/* 고용여부가 Y이고 내배카 금액이 있을 경우
              내배카 지원금 표시 */}
              {courseData.refund.toUpperCase().trim() === 'Y' &&
                courseData.neabaca_grants.trim() !== ('-' || '') && (
                  <div className="p-2 mb-2 neabaca_grants price-info">
                    <p className="mb-2">
                      <MdCreditCard /> <strong>내일배움카드</strong>
                    </p>
                    <p className="mb-1">
                      <IoIosSquare />
                      교육비: {courseData._total_price_.trim()}원
                    </p>
                    <p className="mb-1">
                      <IoIosSquare />
                      내배카 지원금: {courseData.neabaca_grants.trim()}원
                    </p>
                    <p className="mb-1">
                      <IoIosSquare />
                      자부담금:{' '}
                      <strong>
                        {minusCalc(
                          courseData._total_price_,
                          courseData.neabaca_grants,
                        )}
                        원
                      </strong>
                    </p>
                  </div>
                )}
              <div className="extra-info p-2">
                <p className="mb-1">
                  <GoCheck /> {courseData.level || ''}레벨
                </p>
                <p className="mb-1">
                  <GoCheck /> 총 {courseData._number_of_contents_}차시
                </p>
                <p className="mb-1">
                  <GoCheck /> 학습소요기간 {courseData.learning_periods}{' '}
                </p>
              </div>
            </FixedBox>
          </div>
        </div>
      </CourseContentSection>

      <StickBottomBar className="py-2 pe-2 d-block d-lg-none">
        <div className="d-flex justify-content-around align-content-center">
          <button type="button" className="btn btn-block sub-btn">
            <MdAddShoppingCart />
          </button>
          <button type="button" className="btn btn-block sub-btn">
            <FiShare />
          </button>
          <button type="button" className="btn btn-block apply-btn flex-grow-1">
            수강신청
          </button>
        </div>
      </StickBottomBar>
    </Layout>
  );
}
